<template>
  <div />
</template>
<script>
export default {
  mounted() {
    this.signOut();
  },
  methods: {
    async signOut() {
      await this.$axios.post("auth/signout");
      this.$store.dispatch("user/resetUserData");
      localStorage.removeItem("access_token");
      this.$router.push("/signin");
    },
  },
};
</script>